import { TableProps } from "antd";
import ForwardTable from "antd/es/table/Table";
import React from "react";

type Props = {} & TableProps;

const Table = (props: Props): JSX.Element => (
  <ForwardTable
    {...props}
    pagination={{
      ...props.pagination,
      showSizeChanger: false,
    }}
  />
);

export default Table;
